import { PageLinkComponentProps } from "@omni/ui/components/PageLink/pageLink.props";
import { cn } from "@omni/utils/styles";

import { LogoutLinkContainer } from "@/components/Account/LogoutLink/logoutLink.container";
import { Divider } from "@/components/General/Divider/divider.component";
import { PageLinks } from "@/components/General/PageLinks/pageLinks.component";

type Props = {
    links?: Array<PageLinkComponentProps>;
};

const AccountButtonMenu = ({ links }: Props) => {
    return (
        <div className={cn("tw:text-base")}>
            <Divider className={cn("tw:mb-4")} />
            <div className={cn("tw:mx-2")}>
                <PageLinks links={links} />
            </div>
            <Divider className={cn("tw:mb-2")} />
            <div className={cn("tw:mx-2")}>
                <LogoutLinkContainer className={cn("tw:no-underline!")} />
            </div>
        </div>
    );
};

export default AccountButtonMenu;
